module.exports = {
	"es": {
		"ui.about.title.overview": "Mapas Humanitarios recientes",
		"ui.about.subhead": "Descargar mapas humanitarios actualizados para análisis SIG o para usar en dispositivos GPS y smarphones.",
		"ui.about.overview": "",
		"ui.about.title.getting_started": "Cómo empezar",
		"ui.about.getting_started": "",
		"ui.exports": "Exportaciones",
		"ui.exports.title": "Exportaciones",
		"ui.help": "Ayuda",
		"ui.login": "Iniciar sesión",
		"ui.about.license": "",
		"ui.about.license.odbl": "",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Descripción",
		"ui.configuration.description.label": "Descripción",
		"export.description.label": "Descripción",
		"exports.description.label": "Descripción",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Nombre",
		"ui.configuration.name.label": "Nombre",
		"export.name.label": "Nombre",
		"exports.name.label": "Nombre",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "Configuraciones",
		"configuration.title": "Configuraciones",
		"ui.configurations": "Configuraciones",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "",
		"exports.owner.label": "",
		"export.project.label": "",
		"exports.project.label": "",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Publicado",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Características",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "",
		"ui.exports.feature_selection.title": "",
		"export.feature_selection.label": "",
		"ui.close": "",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "Crear exportación",
		"ui.exports.describe_export": "Describir exportaciones",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "Seleccionar características",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "Creado",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privado",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "Buscar",
		"ui.login_to_osm": "Iniciar sesión en OpenStreetMap",
		"ui.hot.title": "Equipo Humanitario de OpenStreetMap",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "Herramienta de exportación OSM",
		"ui.create": "Crear",
		"ui.hdx": "",
		"ui.about": "",
		"ui.log_out": "Cerrar sesión",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/es.json
// module id = 1492
// module chunks = 1